import React from 'react'
import {
  calculateVolumeAndUnits,
  canUseFractionedQuantity,
  convertVolumeAndUnitsToQuantity,
} from '../../../services/util/volume-and-units.service'

function normalizeLabel(value) {
  return typeof value === 'string' ? value.trim() : ''
}

function roundToTwo(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100
}

function formatValue(value) {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return '0'
  return String(roundToTwo(parsed))
}

export function getOrdemColetaQuantityConfig(item = {}) {
  const unitSku = Number(item.unit_sku || 0)
  const caixaComPesoVariavel =
    item.caixa_com_peso_variavel === true || Number(item.caixa_com_peso_variavel) === 1

  return {
    unitSku,
    caixaComPesoVariavel,
    unAgregadora: item.un_agregadora || null,
    unFracionada: item.un_fracionada || null,
    canUseFractionedInput: canUseFractionedQuantity(unitSku, caixaComPesoVariavel),
  }
}

export function getOrdemColetaInputLabels(item) {
  const { unAgregadora, unFracionada } = getOrdemColetaQuantityConfig(item)

  return {
    volumeLabel: normalizeLabel(unAgregadora) || 'Vol',
    unitsLabel: normalizeLabel(unFracionada) || 'Uni',
  }
}

export function buildOrdemColetaQuantityInputState(item, quantity) {
  const { unitSku, caixaComPesoVariavel } = getOrdemColetaQuantityConfig(item)

  if (quantity === '' || quantity === null || quantity === undefined) {
    return { quantityValue: '', volumeValue: '', unitsValue: '' }
  }

  const { volume, units } = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return {
    quantityValue: Number(quantity),
    volumeValue: volume === 0 ? '0' : String(volume),
    unitsValue: units === 0 ? '0' : String(Math.abs(units)),
  }
}

export function getOrdemColetaQuantityValueFromInputs(item, volumeValue, unitsValue) {
  const { unitSku, caixaComPesoVariavel, canUseFractionedInput } =
    getOrdemColetaQuantityConfig(item)

  if (volumeValue === '' && (unitsValue === '' || !canUseFractionedInput || caixaComPesoVariavel)) {
    return ''
  }

  return convertVolumeAndUnitsToQuantity({
    volume: volumeValue,
    units: canUseFractionedInput ? unitsValue : 0,
    unitSku,
    caixaComPesoVariavel,
  })
}

export function getOrdemColetaQuantityVolumeAndUnits(item, quantity) {
  const { unitSku, caixaComPesoVariavel } = getOrdemColetaQuantityConfig(item)
  const { volume, units } = calculateVolumeAndUnits(quantity, unitSku, caixaComPesoVariavel)

  return {
    volume,
    units,
    volumeText: volume === 0 && units < 0 ? '-0' : formatValue(volume),
    unitsText: formatValue(units),
  }
}

function VolumeUnitsPair({ volumeLabel, unitsLabel, volumeText, unitsText }) {
  return (
    <div style={{ display: 'inline-flex', columnGap: 12, justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '0.72rem', color: '#14B0BF' }}>{volumeLabel}</div>
        <div style={{ fontWeight: 600 }}>{volumeText}</div>
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '0.72rem', color: '#14B0BF' }}>{unitsLabel}</div>
        <div style={{ fontWeight: 600 }}>{unitsText}</div>
      </div>
    </div>
  )
}

// Célula Vol/Uni calculada a partir de um item de produto (unit_sku / caixa_com_peso_variavel)
export function renderOrdemColetaQuantityCell(item, quantity) {
  const { volumeText, unitsText } = getOrdemColetaQuantityVolumeAndUnits(item, quantity)
  const { volumeLabel, unitsLabel } = getOrdemColetaInputLabels(item)
  return (
    <VolumeUnitsPair
      volumeLabel={volumeLabel}
      unitsLabel={unitsLabel}
      volumeText={volumeText}
      unitsText={unitsText}
    />
  )
}

// Célula Vol/Uni para totais já calculados pela API (agregados de vários produtos)
export function renderVolumeUnitsCell(volume, units) {
  const volumeNumber = Number(volume) || 0
  const unitsNumber = Number(units) || 0
  return (
    <VolumeUnitsPair
      volumeLabel="Vol"
      unitsLabel="Uni"
      volumeText={volumeNumber === 0 && unitsNumber < 0 ? '-0' : formatValue(volumeNumber)}
      unitsText={formatValue(unitsNumber)}
    />
  )
}

export function formatVolumeUnitsText(volume, units) {
  const volumeNumber = Number(volume) || 0
  const unitsNumber = Number(units) || 0
  const volumeText = volumeNumber === 0 && unitsNumber < 0 ? '-0' : formatValue(volumeNumber)
  return `${volumeText} Vol, ${formatValue(unitsNumber)} Uni`
}
